<template>
    <ui-field v-bind="this.$props" v-slot="{ id }">
        <input 
            :id="id"
            class="m-0 relative rounded-md shadow-sm block w-full border sm:text-sm focus:outline-none focus:ring-brand focus:border-brand"
            :class="[dynamicClasses, field]"
            :placeholder="placeholder"
            :autofocus="autofocus"
            :required="required"
            :disabled="disabled"
            :type="type"
            :name="name"
            :value="value"
            autocomplete="false"
            spellcheck="false"
            ref="input"
            @input="$emit('input', $event.target.value)"
            @change="$emit('change', $event.target.value)"
            @blur="$emit('blur', $event.target.value)"
            @focus="$emit('focus', $event.target.value)"
            @keydown.enter.prevent
        >
    </ui-field>
</template>

<script>
export default {
  props: {
    value: null,
    label: String,
    name: String,
    error: String,
    warning: String,
    info: String,
    placeholder: String,
    autofocus: Boolean,
    required: Boolean,
    disabled: Boolean,
    field: String,
    enableKeyEvents: Boolean,
    noDynamicClasses:  {
        type: Boolean,
        default: false,
    },
    type: {
      type: String,
      default: 'text',
    },
  },
  methods: {
    handleEnterKey(event) {
      // Emit a custom event when Enter is pressed
      this.$emit('enter', event.target.value);
    }
  },
  computed: {
    dynamicClasses() {
      if (this.noDynamicClasses) return'';
      if (this.error) return 'border-red-300'
      if (this.disabled) return 'border-gray-300 text-gray-500 bg-gray-50'
      return 'border-gray-300 placeholder-gray-400'
    }
  }
}
</script>
